import { useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import styles from "./QuestionProfiles.module.css";
import YuJaButton from "../standardization/YuJaButton";
import {YuJaTextBox} from "../standardization/YuJaTextBox";
import {
    TEXTBOX
} from '../../utils/constants';

export default function QuestionBankSearch({buttonStyle, handleSubmit }) {
    const { t } = useTranslation();
    const [keyword, setKeyword] = useState("");

    const clickSearch = () => {
        handleSubmit({ keyword: keyword});
    }

    const enterKeyup = (e) => {
        if (e.key === 'Enter') {
            clickSearch();
        }
    }

    return (
        <div className={styles.searchBox} style={{margin: "0px"}}>
            <Form className={styles.searchBoxForm} onSubmit={e => e.preventDefault()}>
                <YuJaTextBox
                    containerStyle={{marginRight: 15}}
                    placeholder={t("questionBank.searchPlaceholder")}
                    onChange={e => setKeyword(e.target.value)}
                    onKeyUp={enterKeyup}
                    value={keyword}
                >
                </YuJaTextBox>

                <YuJaButton style={buttonStyle} role={TEXTBOX} onClick={clickSearch}>{t("common.search")}</YuJaButton>
            </Form>
        </div>
    );
}